import { render, staticRenderFns } from "./highschool-pricing.vue?vue&type=template&id=15f0edd4&"
import script from "./highschool-pricing.vue?vue&type=script&lang=js&"
export * from "./highschool-pricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports